import React from 'react'

export const NotAuthorized = (props) => {
  return (
    <div className='filter-form-container bg-white' style={{ textAlign: 'center' }}>
      <h1 style={{ color: 'red' }}>Access denied: only Admins can access this page</h1>
    </div>
  )
}
